import { render } from "./ManagedCustomers.vue?vue&type=template&id=ec2e0d16&ts=true"
import script from "./ManagedCustomers.vue?vue&type=script&lang=ts"
export * from "./ManagedCustomers.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-base-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__